import Link from '~/components/Link';
import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';

export type Crumb = {
  label: string;
  path?: string;
};

type Props = {
  breadcrumbs: Crumb[];
};

const BreadcrumbItem = ({
  includeSeparator,
  label,
  onClick,
  path
}: {
  includeSeparator: boolean;
  label: string;
  onClick?: () => void;
  path?: string;
}) => {
  return (
    <li data-cy="breadcrumb" className="text-caption-grey">
      {includeSeparator ? <span className="px-3">•</span> : ''}
      {path ? (
        <Link to={path} onClick={onClick}>
          {label}
        </Link>
      ) : (
        <span>{label}</span>
      )}
    </li>
  );
};

const Breadcrumbs = ({ breadcrumbs }: Props) => {
  const fireNavigationLink = useNavigationLinkInteraction('breadcrumb');

  return (
    <nav>
      <ul className="flex">
        {breadcrumbs.map(({ label, path }, i) => (
          <BreadcrumbItem
            key={label}
            includeSeparator={i > 0}
            label={label}
            onClick={
              path
                ? () => fireNavigationLink(path, i + 1, { label })
                : undefined
            }
            path={path}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
